import {type ElementPosition} from './get-element-position';

export function translatePosition(pos: ElementPosition, translateX: number, translateY: number): ElementPosition {
  const updated = {...pos};

  updated.left += translateX;
  updated.right += translateX;
  updated.top += translateY;
  updated.bottom += translateY;

  return updated;
}
